import React from 'react';
import { Copy } from 'lucide-react';
import { toast } from 'react-toastify';

// Petite icône qui copie une valeur (téléphone, e-mail…) dans le presse-papiers.
function CopyButton({ value, label = 'la valeur' }) {
  const handleCopy = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const text = String(value ?? '').trim();
    if (!text) return;
    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(text);
      } else {
        // Repli pour les contextes non sécurisés (http) : sélection d'un champ caché.
        const ta = document.createElement('textarea');
        ta.value = text;
        ta.style.position = 'fixed';
        ta.style.opacity = '0';
        document.body.appendChild(ta);
        ta.select();
        document.execCommand('copy');
        document.body.removeChild(ta);
      }
      toast.success('Copié dans le presse-papiers');
    } catch {
      toast.error('Copie impossible');
    }
  };

  return (
    <button
      type="button"
      className="copy-btn"
      onClick={handleCopy}
      title={`Copier ${label}`}
      aria-label={`Copier ${label}`}
    >
      <Copy size={14} />
    </button>
  );
}

export default CopyButton;
